import { useMutation } from '@tanstack/react-query'
import { useSearchParams } from 'next/navigation'

import { SimulatorCode } from '@/global/plugins/observability'
import { createSimulation } from '@/modules/simulator/api'
import {
  Simulation,
  UseCreateSimulationProps,
  ValidatedSimulation
} from './useCreateSimulation.types'
import {
  buildPayload,
  handleError,
  validateProps
} from './useCreateSimulation.helpers'

const useCreateSimulation = ({ onSuccess }: UseCreateSimulationProps) => {
  const searchParams = useSearchParams()

  const mutate = (simulation: Simulation) => {
    const validation = validateProps(simulation)

    if (validation.isValid) {
      return create(validation.data)
    }

    return handleError(
      new Error(''),
      SimulatorCode.CREATE_SIMULATION_VALIDATION_ERROR,
      'Erro ao validar dados da simulação'
    )
  }

  const { mutate: create, ...rest } = useMutation({
    mutationFn: (simulation: ValidatedSimulation) => {
      const payload = buildPayload(simulation, searchParams)
      return createSimulation(payload)
    },
    onSuccess,
    onError: (error: Error) =>
      handleError(
        error,
        SimulatorCode.CREATE_SIMULATION_ERROR,
        'Erro ao criar simulação'
      )
  })

  return {
    ...rest,
    mutate
  }
}

export { useCreateSimulation }
